import React, { useEffect, useState } from "react";
import Styles from './styles.module.sass'
import { CheckStatusCard } from "newComponents/Credito/CheckStatusCard";
import { useConsultaSaldoData } from "newHooks/useConsultaSaldoData";
import { RemoveCardSears } from "newComponents/Credito/RemoveCard";
import { NextCardButton } from "newComponents/ModuleNextCardButton";

const ModuleCard = (props) => {
    const {
        cardsService,
        setUdCard,
        clase = ''
    } = props

    const [ NumDepCard, setNumDepCard ] = useState()
    const [ NameCard, setNameCard ] = useState()
    const [ typeAccount, setTypeAccount ] = useState()

    const { dataSaldos, loading, upDateDataSaldos } = useConsultaSaldoData(cardsService)

    useEffect(()=>{
        if(cardsService){
            // console.log('adasdasd: ',cardsService)
            const { cards, name, paternal, maternal } = cardsService
            setNameCard(name+' '+paternal+' '+maternal)
            setNumDepCard(`** **** ** ${cards[0]?.card_number?.substr(-4)}`)
            // setTypeAccount('black')
        }
    },[cardsService])

    return (
        <>
            <div className={`${Styles?.contModuleCard} ${Styles?.[clase]}`}>
                <div className={Styles?.contActionsCard}>
                    <div><CheckStatusCard dataSaldos={dataSaldos}/></div>
                    <RemoveCardSears
                        dataSaldos={dataSaldos}
                        setUdCard={setUdCard}
                    />
                </div>
                <div className={`${Styles?.contCardDepartamental} ${Styles?.[typeAccount]}`}>
                    <div className={Styles?.contNameCard}>{NameCard}</div>
                    <div className={Styles?.contNumberCard}>{NumDepCard}</div>
                     <NextCardButton setUdCard={setUdCard} />
                </div>
            </div>
        </>
    );
}

export default ModuleCard